/* eslint-disable react-hooks/rules-of-hooks */
import {useEffect, useState} from 'react';

import localStorageClient from '../../../services/storage/localStorageClient';
import {OFFLINE_DETECTOR_DISABLED_KEY} from './useDisableOfflineDetector';

const useIsOfflineDetectorEnabled = () => {
    if (process.env.REACT_APP_ENV === 'prod') return true;

    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        const isDisabled = localStorageClient.getItem(OFFLINE_DETECTOR_DISABLED_KEY) === true;

        setIsEnabled(!isDisabled);
    }, []);

    return isEnabled;
};

export default useIsOfflineDetectorEnabled;
